export const DEFAULT_HOMEPAGE_DAC_IMAGE_DOMAIN = 'https://cache.marriott.com';
export const RETARGETING_UXL_PARTIAL_ERROR_EVENT = '[HOMEPAGE][RETARGETING][UXL_PARTIAL_ERROR]';
export const RETARGETING_UXL_REQUEST_ERROR_EVENT = '[HOMEPAGE][RETARGETING][UXL_REQUEST_ERROR]';
